import React from "react";
import { Link } from "react-router";
import { connect } from "react-redux";
import { Permissioned } from "react-permissions";
import Util from "../../util/util";

class QuickLinksMenu extends React.Component {
  render() {
    const { subMenu } = this.props;
    return (
      <Link to={subMenu.route.path} className="list-group-item">
        <i className="fa fa-circle"> </i> <span>{subMenu.title}</span>
      </Link>
    );
  }
}

export default connect(Util.defaultMapStateToProps)(
  Permissioned(QuickLinksMenu)
);



// WEBPACK FOOTER //
// ./src/components/dashboard/QuickLinksMenu.js